import { render, staticRenderFns } from "./voice-talk.vue?vue&type=template&id=5f85708d&scoped=true&"
import script from "./voice-talk.vue?vue&type=script&lang=js&"
export * from "./voice-talk.vue?vue&type=script&lang=js&"
import style0 from "./voice-talk.vue?vue&type=style&index=0&id=5f85708d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f85708d",
  null
  
)

export default component.exports